import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button, Card, Typography } from 'antd';

import { Container } from '@/ui';
import { useProducts } from '@/features/constructorProducts/hooks';

export const ProductsList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading } = useProducts();

  return (
    <>
      <Container $marginBottom={30}>
        <Typography.Title level={4}>{t('Products list')}</Typography.Title>
      </Container>
      {isLoading && <div>{t('Loading')}...</div>}

      {data?.map((product) => (
        <Card
          size='small'
          title={product.type}
          key={product.id}
          style={{ marginBottom: '10px' }}
          styles={{
            header: {
              fontWeight: 300,
              fontSize: '14px'
            }
          }}
        >
          {product.name && <Typography.Title level={5}>{product.name}</Typography.Title>}
          <Typography.Text level={5}>{product.title}</Typography.Text>

          <Container $marginTop={12}>
            <Button
              mode={'strong'}
              onClick={() => navigate(`/constructorProducts/${product.id}`)}
              type='primary'
            >
              Edit
            </Button>
          </Container>
        </Card>
      ))}
    </>
  );
};
